import angular from 'angular';
import display from './builder/display.html';
import data from './builder/data.html';

angular.module('app').run(/* @ngInject */ (
	/** @type {import('angular').ITemplateCacheService} */ $templateCache,
) => {
	$templateCache.put('kform/components/textarea/display.html', display);
	$templateCache.put('kform/components/textarea/data.html', data);
});
